var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-date-picker',{attrs:{"view2":true,"initialView":"days","value":_vm.dateFrom || new Date(),"dateSecond":_vm.dateTo || new Date(),"isDateRange":true},on:{"inputrange":_vm.onChangeDateFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }